import { get_token, get_user_details } from "@/router";

export function get_branding_profile(current_profile, active_base_profile) {
  return current_profile || active_base_profile || {};
}

export function get_branding_company(profile = {}) {
  return profile.company || profile;
}

export function create_empty_address_list() {
  return {
    street_address: "",
    suburb: "",
    town: "",
    province: "",
    postal_code: "",
    country: "",
  };
}

export function create_empty_user_details() {
  return {
    user_role: "",
    first_name: "",
    last_name: "",
  };
}

export function get_first_defined_value(...values) {
  return values.find((value) => value !== undefined && value !== null && String(value).trim() !== "") || "";
}

export function get_company_profile_value(...values) {
  return get_first_defined_value(...values);
}

export function build_company_profile_address_values(business = {}) {
  return {
    street_address: get_company_profile_value(business.street_address),
    suburb: get_company_profile_value(business.suburb, business.local_area, business.address?.suburb),
    town: get_company_profile_value(business.town, business.city, business.address?.city),
    province: get_company_profile_value(business.province, business.address?.province),
    postal_code: get_company_profile_value(business.postal_code, business.code, business.address?.postal_code),
    country: get_company_profile_value(business.country, business.address?.country),
  };
}

export function create_home_nav_session_state() {
  return {
    expanded_section: null,
    search_history: [],
    filtered_recent: [],
    token_exists: false,
    user_id: null,
    has_membership_card: false,
    cbo_domain: false,
    visible_domain: false,
    user_details: create_empty_user_details(),
    show_menu: false,
    show_cart: false,
    show_icons: false,
    show_search: false,
    users: [],
    filtered_profiles: [],
    search_query: "",
    is_sidebar_open: false,
    is_event_sidebar_open: false,
  };
}

export function create_home_nav_profile_state() {
  return {
    company_name: "",
    type_of_organization: [],
    description: "",
    email: "",
    tell_number: "",
    location: "",
    address_list: create_empty_address_list(),
    organization_types: [],
    errors: {},
    is_loading: false,
    profile_switch_loading: false,
    selected_type_of_organization: "",
    type_of_profile: [],
    selected_profile: null,
    base_profiles: [],
    current_profile: null,
    display_letter: "",
    display_name: "",
    is_business_profile: false,
    company_data: null,
    show_all: false,
    profile_questions: [],
    workbook_domain: false,
    search_timeout: null,
    is_edit_mode: false,
    base_profile_id: null,
    longitude: null,
    latitude: null,
    company_address_autocomplete: null,
    company_address_input: null,
  };
}

export function create_home_nav_notification_state() {
  return {
    receive_emails: true,
    receive_notifications: true,
    show_notification_settings: false,
    soulcity_domain: false,
    school_domain: false,
    marketplace_domain: false,
    vettedsa_domain: false,
    organization_logo: localStorage.getItem("organization_logo") || "",
    saved_branding: null,
    organization_branding_loading: false,
  };
}

export function create_home_nav_data() {
  return {
    ...create_home_nav_session_state(),
    ...create_home_nav_profile_state(),
    ...create_home_nav_notification_state(),
  };
}

export function initialize_home_nav_component(vm, client_domain) {
  initialize_home_nav_state(vm);
  load_home_nav_resources(vm);
  register_home_nav_events(vm);
  configure_home_nav_domains(vm, client_domain);
  bind_company_profile_modal_events(vm);
  register_home_nav_offcanvas_events(vm);
}

function initialize_home_nav_state(vm) {
  vm.token_exists = get_token();
  vm.user_details = {
    ...create_empty_user_details(),
    ...(get_user_details() || {}),
  };
  vm.user_id = vm.get_user_id();
}

function load_home_nav_resources(vm) {
  if (!vm.token_exists) {
    vm.load_google_map_event();
    return;
  }

  vm.load_google_map_event();
  vm.fetch_type_of_organization();
  vm.fetch_type_of_profile();
  vm.get_all_profile();
  vm.fetch_profiles();
  vm.toggle_show_all();
  vm.get_active_profile();
  vm.load_active_profile_branding();
  vm.get_search_history();
  vm.check_membership_card();
}

function register_home_nav_events(vm) {
  document.addEventListener("click", vm.handle_outside_click);
  window.addEventListener("organization-branding-updated", vm.handle_organization_branding_updated);
  window.addEventListener("organization-profile-updated", vm.handle_organization_profile_updated);
}

function configure_home_nav_domains(vm, client_domain) {
  vm.visible_domain = home_nav_has_visible_domain(client_domain);
  vm.marketplace_domain = home_nav_domain_includes(client_domain, ["vettedsa", "engagenet"]);
  vm.vettedsa_domain = home_nav_domain_includes(client_domain, ["vettedsa"]);
  vm.workbook_domain = home_nav_domain_includes(client_domain, ["workbook"]);
  vm.school_domain = home_nav_domain_includes(client_domain, ["chiefluthuli"]);
  vm.soulcity_domain = home_nav_domain_includes(client_domain, ["soulcity", "nsp", "dwypd", "aicreads"]);
  vm.cbo_domain = home_nav_domain_includes(client_domain, ["cbo"]);
}

function home_nav_has_visible_domain(client_domain) {
  return home_nav_domain_includes(client_domain, [
    "cbo", "tdm", "chamber", "demo", "engagenet", "dwypd", "bosa", "apex", "vettedsa",
  ]);
}

function home_nav_domain_includes(client_domain, domains) {
  return domains.some((domain) => client_domain.includes(domain));
}

function bind_company_profile_modal_events(vm) {
  if (vm.visible_domain) {
    $("#company_profile_modal").on("hidden.bs.modal", () => {
      vm.update_first_time_login_status();
    });
  }

  $("#company_profile_modal").on("shown.bs.modal", () => {
    vm.load_google_map_event();
  });
}

function register_home_nav_offcanvas_events(vm) {
  vm.$nextTick(() => bind_home_nav_offcanvas_events(vm));
}

function bind_home_nav_offcanvas_events(vm) {
  const home_nav_offcanvas = document.getElementById("offcanvasExample");
  if (!home_nav_offcanvas) return;

  vm.home_nav_offcanvas_show_handler = () => {
    vm.$el?.classList?.add("home-nav-offcanvas-active");
  };
  vm.home_nav_offcanvas_hidden_handler = () => {
    vm.$el?.classList?.remove("home-nav-offcanvas-active");
  };

  home_nav_offcanvas.addEventListener("show.bs.offcanvas", vm.home_nav_offcanvas_show_handler);
  home_nav_offcanvas.addEventListener("hidden.bs.offcanvas", vm.home_nav_offcanvas_hidden_handler);
}

export function build_company_edit_state(business = {}) {
  const { address = {}, base_profile, ...data } = business;

  return {
    is_edit_mode: true,
    company_name: data.company_name,
    selected_type_of_organization: data.type_of_organization,
    description: get_first_defined_value(data.description),
    email: get_first_defined_value(data.email),
    tell_number: get_first_defined_value(data.tell_number),
    location: get_first_defined_value(data.location),
    address_list: build_company_profile_address_values({ ...data, address }),
    latitude: get_nullable_value(data.latitude, address.latitude),
    longitude: get_nullable_value(data.longitude, address.longitude),
    base_profile_id: base_profile?.id,
  };
}

function get_nullable_value(...values) {
  const value = values.find((item) => item !== null && typeof item !== "undefined");
  return typeof value === "undefined" ? null : value;
}

export function load_company_profile_google_map(component, google_map_api_key) {
  if (!google_map_api_key) return;

  component.register_company_profile_map_callback();

  if (component.google_places_is_ready()) {
    component.initialize_company_profile_map_on_next_tick();
    return;
  }

  const existing_script = document.getElementById("googleMapsScript");

  if (existing_script) {
    existing_script.addEventListener(
      "load",
      () => component.initialize_company_profile_map_on_next_tick(),
      { once: true }
    );
    return;
  }

  document.head.appendChild(component.create_google_maps_script());
}

function normalize_profile_type_name(profile_type) {
  return String(profile_type?.name || profile_type?.profile_type || profile_type || "").toLowerCase();
}

function profile_type_value(profile_type) {
  return profile_type?.id ?? profile_type;
}

export function profile_matches_type(profile, name, profile_type_id) {
  const expected_name = String(name || "").toLowerCase();
  const profile_type = profile?.profile_type;

  const matches_name = normalize_profile_type_name(profile_type) === expected_name;

  const matches_id =
    profile_type_id !== null &&
    String(profile_type_value(profile_type)) === String(profile_type_id);

  return matches_name || matches_id;
}
